import {
  MONDAY_CONNECT_SUCCESS,
  MONDAY_CONNECT_FAIL,
  MONDAY_LOADING,
  MONDAY_SYNC_START,
  MONDAY_SYNC_PROGRESS,
  MONDAY_SYNC_COMPLETE,
  MONDAY_SYNC_FAIL,
  MONDAY_RESET
} from '../actions/types';

const initialState = {
  loading: false,
  connected: false,
  boardId: null,
  boardName: '',
  groups: [],
  itemCols: [],
  subCols: [],
  error: null,
  syncing: false,
  syncProgress: 0,
  syncTotal: 0,
  syncDone: false
};

export default function mondayReducer(state = initialState, action) {
  switch (action.type) {
    case MONDAY_LOADING:
      return { ...state, loading: true, error: null };
    case MONDAY_CONNECT_SUCCESS:
      return {
        ...state,
        loading: false,
        connected: true,
        error: null,
        ...action.payload
      };
    case MONDAY_CONNECT_FAIL:
      return { ...state, loading: false, connected: false, error: action.payload };
    case MONDAY_SYNC_START:
      return { ...state, syncing: true, syncProgress: 0, syncTotal: action.payload, syncDone: false };
    case MONDAY_SYNC_PROGRESS:
      return { ...state, syncProgress: action.payload };
    case MONDAY_SYNC_COMPLETE:
      return { ...state, syncing: false, syncDone: true };
    case MONDAY_SYNC_FAIL:
      return { ...state, syncing: false, error: action.payload };
    case MONDAY_RESET:
      return initialState;
    default:
      return state;
  }
}
